// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

let configsecrets = {};

configsecrets.emailservicetoken = '7as7shsb';

export default configsecrets;
